import { useQuery } from "react-query";
import {
  checkLandingPage,
  getFeedControls,
  getUserAndCheckExistence,
} from "../HelperFunction/HelperFunction";

export function useLoadProfileSetup(username: any, page: any) {
  async function fetchAllData() {
    const userData: any = await getUserAndCheckExistence(username);
    if (Object.keys(userData) && !userData?.user_id) {
      return {
        userNotFound: true,
        combinedRes: null,
      };
    }
    const {
      user_id,
      instagram_links,
      userExists,
      description,
      search_bar_text,
      search_bar_tags,
      social_links_order,
      is_fillout_on,
      is_embed_search,
    } = userData;
    await checkLandingPage(user_id);
    const feedControls: any = await getFeedControls(page, user_id);

    const combinedRes = {
      userData: userData,
      feedControls: feedControls,

      userExists: userExists,

      is_embed_search: is_embed_search,
      instagram_links: instagram_links,
      description: description,
      search_bar_text: search_bar_text,
    };

    return { combinedRes: combinedRes, userNotFound: false };
  }
  return useQuery(["fetchProfileSetup", username, page], fetchAllData, {
    refetchOnWindowFocus: true,
  });
}
